<script lang="ts">
	import Icon from '../../components/icon/Icon.svelte'
	import { getPricingContext } from './pricingContext'
	import { ChevronLeft, ChevronRight } from '@steeze-ui/heroicons'
	import { fade } from 'svelte/transition'

	interface Props {
		pricingContainer: HTMLDivElement
		containerScrollLeft: number
	}

	let { pricingContainer, containerScrollLeft }: Props = $props()

	let isFirst = $derived(containerScrollLeft === 0)
	let isLast = $derived(
		Math.abs(containerScrollLeft + pricingContainer.clientWidth - pricingContainer.scrollWidth) < 1,
	)

	function scrollToNext() {
		pricingContainer.scrollTo({
			left: containerScrollLeft + pricingContainer.clientWidth,
			behavior: 'smooth',
		})
	}

	function scrollToPrevious() {
		pricingContainer.scrollTo({
			left: containerScrollLeft - pricingContainer.clientWidth,
			behavior: 'smooth',
		})
	}

	const { inModal } = getPricingContext()
</script>

<div
	class="
        pointer-events-none sticky top-1/2 z-20 flex h-20 flex-1 items-center justify-between md:hidden
        {inModal ? 'max-md:-mx-7' : ''}
    "
>
	{#if !isFirst}
		<button
			transition:fade={{ duration: 200 }}
			class="pointer-events-auto"
			onclick={scrollToPrevious}
		>
			<div class="text-muted">
				<Icon src={ChevronLeft} xLarge />
			</div>
		</button>
	{/if}

	{#if !isLast}
		<button
			transition:fade={{ duration: 200 }}
			class="pointer-events-auto ml-auto"
			onclick={scrollToNext}
		>
			<div class="text-muted">
				<Icon src={ChevronRight} xLarge />
			</div>
		</button>
	{/if}
</div>
